import { render, staticRenderFns } from "./CreditCardRadioBlock.vue?vue&type=template&id=536dcbfa&"
import script from "./CreditCardRadioBlock.vue?vue&type=script&lang=js&"
export * from "./CreditCardRadioBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports